<template>
  <!-- 计划看板 -->
  <div v-if="taskList.length>0" class="taskBoard">
    <!-- 计划进度统计 -->
    <div class="taskProgress">
      <div class="prjTitle">
        <span>{{ prjObj.prjName }}</span>
        <div class="nowProgress">当前进度：</div>
        <el-progress :percentage="currentProgress" style="width: 220px" :stroke-width="8" color="#0ABB87">
        </el-progress>
      </div>

      <!-- 节点行 -->
      <div class="nodes">
        <div class="tabNode">
          <div class="tabRing">
            <div class="greyLine"></div>
          </div>
          <el-tag size="small">计划完成时间</el-tag><br>
          <el-tag size="small" type="success">实际完成时间</el-tag>
        </div>

        <div v-for="item in taskList" :key="item.taskId" class="node" @click="changeTask(item)">
          <div class="node_name">{{ item.taskName }}</div>
          <div class="ring">
            <div class="greyLine"></div>
            <div v-if="item.isSuspend===1" class="ring_orange" :class="[taskCur==item.taskId?'ring_orange_active':'']"></div>
            <div v-if="!item.isSuspend&&item.taskStatus===0" class="ring_grey" :class="[taskCur==item.taskId?'ring_grey_active':'']"></div>
            <div v-if="!item.isSuspend&&item.taskStatus===1" class="ring_green" :class="[taskCur==item.taskId?'ring_green_active':'']"></div>
            <div v-if="!item.isSuspend&&item.taskStatus===2" class="ring_blue" :class="[taskCur==item.taskId?'ring_blue_active':'']"></div>
            <div v-if="!item.isSuspend&&item.taskStatus===3" class="ring_red" :class="[taskCur==item.taskId?'ring_red_active':'']"></div>
            <div class="greyLine"></div>
          </div>
          <div class="planDate">{{ item.endDate }}</div>
          <div class="actualDate">{{ timeFormat(item.realEndDate) }}</div>
        </div>

        <div class="tabNode">
          <div class="tabRing">
            <div class="greyLine"></div>
          </div>
          <div style="height: 60px"></div>
        </div>
      </div>
    </div>
    <div class="flow">
      <div v-if="specList.length>0" class="nodes">
        <div class="tabNode">
          <el-tag size="small">开始时间</el-tag> <br>
          <el-tag size="small" type="success">完成时间</el-tag>
        </div>
        <div v-for="(item,index) in specList" :key="item.specId" class="node">
          <div class="nodeLeft" :class="[specCur===item.specId?'specActive':'']" @click="changeSpec(item)">
            <img :src="stateImg(item.flowStatus)">
            <div class="node_name">{{ item.specName }}</div>
            <div class="planDate">{{ item.startDate }}</div>
            <div class="actualDate">{{ item.endDate }}</div>
          </div>
          <div v-show="index!==specList.length-1" class="nodeRight">
            <img :src="transition">
          </div>
        </div>
      </div>
      <div v-if="specList.length>0" class="tableStyle">
        <el-table :data="taskProcessList" border mix-height="300px" max-height="500px" style="width: 100%">
          <el-table-column type="index" label="编号" width="60" />
          <el-table-column label="状态" prop="status" width="80px" align="center">
            <template slot-scope="scope">
              <flowStatus :status="scope.row.status" />
            </template>
          </el-table-column>
          <el-table-column label="流程类型" prop="flowType" min-width="80px" />
          <el-table-column label="专业" prop="specName" min-width="150px" show-overflow-tooltip />
          <el-table-column label="标题" prop="title" min-width="150px" show-overflow-tooltip />
          <el-table-column label="内容" prop="content" min-width="200px" width="*" show-overflow-tooltip />
          <el-table-column label="申请人" prop="flowInstanceOwnerName" min-width="120px" show-overflow-tooltip />
          <el-table-column label="开始时间" prop="flowInstanceStartTime" min-width="120px" show-overflow-tooltip />
          <el-table-column label="当前审批人" prop="currentNodeAssigneeName" min-width="120px" show-overflow-tooltip />
          <el-table-column label="上个审批节点" prop="lastNodeName" min-width="100px" show-overflow-tooltip />
        </el-table>
        <el-pagination background :total="totalCount" :page-size="pageSize" :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev, pager, next, jumper"
          style="text-align: end;margin-top:var(--middle-space)" @size-change="handleSizeChange" @current-change="currentChange" />
      </div>
      <div v-else class="noData">
        暂无专业数据
      </div>
    </div>

    <!-- 人员计划数统计 -->
    <div class="title">
      <div class="title_left">
        <el-divider direction="vertical"></el-divider>
        <span>人员计划数统计</span>
      </div>
      <div class="title_right">
        <span>排序方式：</span>
        <el-select v-model="sortOrder" size="small" clearable placeholder="按计划总数排序" @change="personTask_setOption">
          <el-option v-for="item in sortOrders" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>

        <span>所属部门：</span>
        <el-cascader v-model="department" :options="departments" size="small" clearable placeholder="全部"
          :props="{value: 'deptId', label: 'deptName', children: 'children', checkStrictly: true }"
          @change="personTask_setOption">
        </el-cascader>
      </div>
    </div>
    <div class="personTaskNum">
      <div class="personTask_board">
        <!-- 存放图像文件 -->
        <div ref="personTask" class="personTask_slider"></div>
      </div>
    </div>
  </div>
  <div v-else class="taskNoData">
    <img :src="noDataImg">
  </div>
</template>

<script>
import { mapState } from "vuex";
import dataBoardService from "@/CommonDP/service/dataBoard-service.js";
import moment from "moment";
import flowStatus from "@/CommonDP/components/flowComponents/flowStatus";
import progressService from "@/CommonDP/service/progress-service";
import * as echarts from 'echarts';
var personTask; // 人员计划数统计图

export default {
  components: { flowStatus },
  data() {
    return {
      currentProgress: 0, // 当前进度
      taskList: [], // 计划列表
      specList: [], // 专业列表

      completed: require("@/CommonDP/assets/projectMg/dataBoard/completed.png"),
      inProgress: require("@/CommonDP/assets/projectMg/dataBoard/inProgress.png"),
      notStarted: require("@/CommonDP/assets/projectMg/dataBoard/notStarted.png"),
      transition: require("@/CommonDP/assets/projectMg/dataBoard/transition.png"),

      sortOrders: [
        { label: "计划总数", value: "totalNum" },
        { label: "进行中", value: "inProgressNum" },
        { label: "已完成", value: "completedNum" },
        { label: "已延期", value: "overdueNum" }
      ], // 排序方式
      sortOrder: "totalNum",
      departments: [], // 所属部门
      department: [],

      peoplePlanTaskNum: [], // 人员计划数统计数据
      flowList: [],
      specCur: '',
      taskCur: '',
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0,
      taskProcessList: [],
      noDataImg: require("@/CommonDP/assets/workProjectBoard/notNotice.png")

    };
  },
  computed: {
    ...mapState({
      prjObj: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),

    personTaskData() {
      const personTaskData = this.peoplePlanTaskNum;
      if (this.sortOrder) {
        personTaskData.sort(this.arraySort(this.sortOrder));
      }
      return personTaskData;
    }
  },
  mounted() {
    this.getDepartments();
    this.getProgress();
  },
  methods: {
    // 排序
    arraySort(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value2 - value1;
      };
    },

    stateImg(stateImg) {
      switch (stateImg) {
        case 1:
          return this.completed;
        case 2:
          return this.inProgress;
        case 3:
          return this.notStarted;
      }
    },

    // 实际完成时间展示规范
    timeFormat(time) {
      if (time) {
        return moment(time, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
      } else {
        return "";
      }
    },

    // 获得部门数据
    async getDepartments() {
      const res1 = await dataBoardService.getDepartments(this.enterpriseId);
      this.departments = this.getTreeData(res1.data);
    },

    // 递归判断列表，把最后的children设为undefined
    getTreeData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },

    // 获取计划进度统计数据
    async getProgress() {
      const params = {
        prjId: this.prjObj.prjId
      };
      const res = await dataBoardService.getProgress(params);
      this.currentProgress = res.data.currentProgress.slice(0, -1) - "0";
      this.taskList = res.data.taskList;
      this.taskCur = this.taskList[0] ? this.taskList[0].taskId : "";
      if (this.taskCur) {
        this.personTask_init();
        this.getSpec(this.taskCur);
      }
    },
    // 获取计划进度统计数据
    async getSpec(taskId) {
      const res = await dataBoardService.getSpecList(taskId);
      this.specList = res.data;
      this.specCur = res.data[0] ? res.data[0].specId : '';
      if (this.specCur) {
        this.queryTaskProcessList();
      }
    },

    // 获取人员计划数统计数据
    async getPeoplePlanTaskNum() {
      const params = {
        prjId: this.prjObj.prjId,
        deptId: this.department[this.department.length - 1] // 部门id
      };
      const res = await dataBoardService.getPeoplePlanTaskNum(params);
      this.peoplePlanTaskNum = res.data;
    },

    // 人员计划数统计_初始化
    personTask_init() {
      this.$nextTick(() => {
        personTask = echarts.init(this.$refs.personTask);
        this.personTask_setOption();
      });
    },

    // 人员计划数统计_加载数据
    personTask_setOption() {
      this.getPeoplePlanTaskNum().then(() => {
        const x_users = this.personTaskData.map((item) => item.name);
        const x_roles = this.personTaskData.map((item) => item.roleList[0].roleName);
        const totalNum = this.personTaskData.map((item) => item.totalNum); // 计划总数
        const inProgressNum = this.personTaskData.map((item) => item.inProgressNum); // 进行中的计划
        const completedNum = this.personTaskData.map((item) => item.completedNum); // 已完成的计划数
        const overdueNum = this.personTaskData.map((item) => item.overdueNum); // 已延期的计划数
        for (let index = 0; index < x_users.length; index++) {
          if (totalNum[index] === 0 && inProgressNum[index] === 0 && completedNum[index] === 0 && overdueNum[index] === 0) {
            totalNum.splice(index, 1);
            inProgressNum.splice(index, 1);
            completedNum.splice(index, 1);
            overdueNum.splice(index, 1);
            x_users.splice(index, 1);
            x_roles.splice(index, 1);
            index--;
          }
        }
        const option = {
          color: ["CornflowerBlue", "Orange", "MediumAquamarine", "LightCoral", "LightGrey"],
          // 图例
          legend: {
            orient: "horizontal", // 水平布局
            bottom: "0%",
            x: "center",
            itemGap: 40, // 间隔
            data: ["计划总数", "进行中", "已完成", "已延期"]
          },
          // x轴
          xAxis: [
            {
              type: "category",
              offset: 6,
              data: x_users,
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#DCDCDC"
                }
              }, // 轴线
              axisLabel: { color: "#646464" }, // 标签
              axisTick: {
                show: false
              } // 刻度
            },
            {
              type: "category",
              data: x_roles,
              position: "bottom",
              offset: 30,
              axisLine: { show: false }, // 轴线
              axisLabel: { color: "#646464" }, // 标签
              axisTick: {
                show: false
              } // 刻度
            }
          ],
          // y轴
          yAxis: {
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "#DCDCDC"
              }
            }, // 轴线
            axisLabel: { color: "#646464" }, // 标签
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#F5F5F5"
              }
            } // 分割线
          },
          // 坐标轴定位
          grid: {
            top: "5%",
            width: "100%",
            left: "0",
            containLabel: true
          },
          // 滚动滑块
          dataZoom: [
            {
              startValue: 0,
              endValue: 6,
              zoomLock: false, // 锁定滑块大小
              handleSize: 6,
              showDetail: false, // 滑块两端信息
              showDataShadow: false, // 数据阴影可以简单地反应数据走势
              brushSelect: false,
              show: true,
              height: 6,
              right: 6,
              backgroundColor: "rgba(220, 220, 220, 0.3)", // 背景颜色
              borderColor: "rgb(0 0 0 0.3);", // 边框颜色
              fillerColor: "rgba(200, 200, 200, 0.88)", // 滑块颜色
              handleIcon: "circle", // 滑块两端圆形
              handleStyle: {
                color: "rgba(200, 200, 200, 1)", // 滑块两端圆形颜色
                borderWidth: 0
              }
            }
          ],
          // 列表
          series: [
            {
              name: "计划总数",
              type: "bar",
              barWidth: 15, // 柱图宽度
              data: totalNum
            },
            {
              name: "进行中",
              type: "bar",
              barWidth: 15, // 柱图宽度
              data: inProgressNum
            },
            {
              name: "已完成",
              type: "bar",
              barWidth: 15, // 柱图宽度
              data: completedNum
            },
            {
              name: "已延期",
              type: "bar",
              barWidth: 15, // 柱图宽度
              data: overdueNum
            }
          ],
          // 提示
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(0, 0, 0, 0.62)",
            padding: [15, 20, 15, 15],
            borderWidth: 0,
            textStyle: {
              fontFamily: "PingFang SC",
              fontSize: 14,
              color: "#ffffff"
            },
            extraCssText: "line-height: 24px",
            axisPointer: {
              type: "shadow"
            }
          }
        };
        if (x_users.length < 8) option.dataZoom = [];
        personTask.setOption(option, true);
      });
    },
    changeSpec(val) {
      this.specCur = val.specId;
      this.queryTaskProcessList();
    },
    changeTask(val) {
      this.taskCur = val.taskId;
      this.getSpec(this.taskCur);
    },
    queryTaskProcessList() {
      const { prjId } = this.prjObj;
      const pageNum = this.pageIndex;
      const pageSize = this.pageSize;
      const params = {
        enterpriseId: this.enterpriseId,
        prjId,
        specId: this.specCur,
        taskId: this.taskCur
      };
      progressService
        .queryPrjAllPage(params, pageNum, pageSize)
        .then((res) => {
          if (res.result === "0") {
            this.taskProcessList = res.data;
            this.totalCount = res.totalCount;
          }
        })
        .catch((e) => {
          this.$message.warning(e.message || "流程失败");
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.queryTaskProcessList();
    },
    currentChange(val) {
      this.pageIndex = val;
      this.queryTaskProcessList(val);
    }
  }
};
</script>

<style lang='scss' scoped>
.taskBoard {
  width: 100%;

  .taskProgress {
    width: 100%;
    padding: var(--big-space);
    border-radius: 0 0 4px 4px;
    background-color: white;
    margin-bottom: var(--middle-space);

    .prjTitle {
      width: max-content;
      padding: 9px 11px;
      background-color: rgba(212, 217, 236, 0.21);
      display: flex;
      align-items: center;

      span {
        font-size: 14px;
        line-height: 18px;
        font-weight: 400;
        color: var(--key-color);
        white-space: nowrap;
      }

      .nowProgress {
        padding-left: 35px;
        font-size: 14px;
        line-height: 18px;
        color: var(--key-color);
        white-space: nowrap;
      }

      .el-progress {
        display: flex;
        align-items: center;

        /deep/ .el-progress__bar {
          padding: 0;
        }
      }
    }

    .nodes {
      width: 100%;
      padding: var(--big-space);
      overflow-x: auto;
      display: flex;
      align-items: center;

      .tabNode {
        width: 90px;
        flex-grow: 1;

        .tabRing {
          width: 100%;
          height: 40px;
          margin-top: 18px;

          display: flex;
          align-items: center;

          .greyLine {
            width: 1px;
            height: 8px;
            flex-grow: 1;
            background: #f2f3f5;
          }
        }

        .el-tag {
          border-radius: 12px;
          margin: 3px 0;
        }
      }

      .node {
        width: calc(16% - 30px);
        min-width: 150px;
        text-align: center;

        .node_name {
          max-width: 100%;
          font-size: 16px;
          line-height: 18px;
          font-weight: 700;
          color: var(--key-color);
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .ring {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .ring_grey{
            width: 40px;
            height: 40px;
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_grey.png") center center no-repeat;
          }
          .ring_grey:hover{
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_grey_move.png") center center no-repeat;
          }
          .ring_grey_active{
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_grey_active.png") center center no-repeat;
          }

          .ring_blue{
            width: 40px;
            height: 40px;
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_blue.png") center center no-repeat;
          }
          .ring_blue:hover{
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_blue_move.png") center center no-repeat;
          }
          .ring_blue_active{
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_blue_active.png") center center no-repeat;
          }

          .ring_green{
            width: 40px;
            height: 40px;
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_green.png") center center no-repeat;
          }
          .ring_green:hover{
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_green_move.png") center center no-repeat;
          }
          .ring_green_active{
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_green_active.png") center center no-repeat;
          }

          .ring_red{
            width: 40px;
            height: 40px;
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_red.png") center center no-repeat;
          }
          .ring_red:hover{
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_red_move.png") center center no-repeat;
          }
          .ring_red_active{
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_red_active.png") center center no-repeat;
          }

          .ring_orange{
            width: 40px;
            height: 40px;
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_orange.png") center center no-repeat;
          }
          .ring_orange:hover{
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_orange_move.png") center center no-repeat;
          }
          .ring_orange_active{
            background: url("../../../../../../CommonDP/assets/projectMg/dataBoard/ring_orange_active.png") center center no-repeat;
          }

          .greyLine {
            width: 1px;
            height: 8px;
            flex-grow: 1;
            background: #f2f3f5;
          }
        }

        .planDate {
          width: 100%;
          height: 30px;
          line-height: 30px;
          text-align: center;
          white-space: nowrap;
        }

        .actualDate {
          width: 100%;
          height: 30px;
          line-height: 30px;
          text-align: center;
          white-space: nowrap;
        }
      }
    }
  }
  .flow{
    width: 100%;
    padding: var(--middle-space) var(--big-space);
    border-radius: 0 0 4px 4px;
    background-color: white;
    margin-bottom: var(--middle-space);
    .nodes {
      width: 100%;
      padding: var(--big-space);
      overflow-x: auto;
      display: flex;
      align-items: flex-end;

      .tabNode {
        width: 90px;
        .tabRing {
          width: 100%;
          height: 40px;
          margin-top: 18px;

          display: flex;
          align-items: center;

          .greyLine {
            width: 1px;
            height: 8px;
            flex-grow: 1;
            background: #f2f3f5;
          }
        }

        .el-tag {
          border-radius: 12px;
          margin: 3px 0;
        }
      }

      .node {
        width: calc(16% - 30px);
        min-width: 150px;
        display: flex;
        .nodeLeft{
          width:110px;
          text-align: center;
          img {
            margin-top: 5px;
            margin-bottom: 5px;
          }
          .node_name {
            max-width: 100%;
            font-size: 16px;
            line-height: 18px;
            font-weight: 700;
            color: var(--key-color);
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .planDate {
            width: 100%;
            height: 30px;
            line-height: 30px;
            text-align: center;
            white-space: nowrap;
          }
          .actualDate {
            width: 100%;
            height: 30px;
            line-height: 30px;
            text-align: center;
            white-space: nowrap;
          }
        }
        .specActive{
          background: #F5F6FB;
          border-radius: 6px;
        }
        .nodeRight{
          margin-top:10px;
          width: 110px;
          text-align: center;
        }
      }
    }
    .tableStyle{
      padding: var(--middle-space) var(--big-space);
    }
    .noData{
      text-align: center;
      font-size: 15px;
    }
  }
  .personTaskNum {
    .personTask_board {
      width: 100%;
      padding: 40px 4% 40px;
      border-radius: 0 0 4px 4px;
      background-color: white;

      display: flex;
      justify-content: center;
      align-items: center;

      .personTask_slider {
        width: 1440px;
        height: 360px;
      }
    }
  }
}

.title {
  width: 100%;
  padding: var(--small-space) var(--big-space);
  border-bottom: 1px solid #e6eaf8;
  border-radius: 4px 4px 0 0;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title_left {
    display: flex;
    align-items: center;

    .el-divider {
      background-color: var(--theme-color);
      width: 3px;
      height: 15px;
      margin: 0 8px 0 0;
    }

    span {
      font-size: 16px;
      line-height: 22px;
      font-weight: 700;
      color: var(--key-color);
      white-space: nowrap;
    }
  }

  .title_right {
    display: flex;
    align-items: center;

    span {
      font-family: "Microsoft YaHei UI";
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: var(--common-color);
      white-space: nowrap;

      padding-left: 25px;
    }
  }
}
.taskNoData{
  width: 100%;
  height: calc(100vh - 122px);
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
